import { isObject } from 'lodash';
import { useEffect, useState } from 'react';
import { InvoicePayload, invoicePayloadSchema } from '../schemas/pushNotificationSchemas';
import { useNavigate } from 'react-router-dom';
import { PAGE_ID } from 'core/datasets/page_id';

type UseNotificationInvoiceData = (payloadData: unknown) => void;

export default function useNotificationInvoiceData(): UseNotificationInvoiceData {
    const [payloadData, setPayloadData] = useState<InvoicePayload | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (payloadData) {
            navigate(`/${PAGE_ID.INVOICE.toLocaleLowerCase()}/${payloadData.invoice_id}`);
        }

        return () => {
            setPayloadData(null);
        };
    }, [payloadData, navigate]);

    const setPayloadHandler = (payloadData: unknown) => {
        if (payloadData && isObject(payloadData)) {
            try {
                const invoicePayload = invoicePayloadSchema.validateSync(payloadData);
                setPayloadData(invoicePayload);
            } catch (error) {
                setPayloadData(null);
            }
        }
    };

    return setPayloadHandler;
}
